if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            function afterAddToCart(thisC){
              // console.log("afterAddToCart",thisC, thisC.cart);
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                thisC.handleErrorMessage(response.description);
  
                const soldOutMessage = thisC.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                thisC.submitButton.setAttribute('aria-disabled', true);
                thisC.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                thisC.error = true;
                return;
              } else if (!thisC.cart) {
                window.location = window.routes.cart_url;
                return;
              }
  
              if (!thisC.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              thisC.error = false;
              const quickAddModal = thisC.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      thisC.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                thisC.cart.renderContents(response);
              }
            }
            let upsellCheckbox = document.querySelector("[data-upsell-product]") || null;
            if(upsellCheckbox && upsellCheckbox.checked){
              const upsell = {};
              upsell.id = upsellCheckbox.value;
              upsell.quantity = 1;
              if (this.cart) {
                upsell.sections = this.cart.getSectionsToRender().map((section) => section.id)
                upsell.sections_url = window.location.pathname;
              }
              // console.log("upsell",upsell);
              fetch('/cart/add.js', {
                method: 'POST',
                headers: { "Accept": "application/json", "Content-Type": "application/json" },
                body: JSON.stringify(upsell)
              })
              .then((response) => response.json())
              .then((response) => {
                // console.log("upsell response",response);
                afterAddToCart(this);
              });
            }else{
              afterAddToCart(this);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            this.submitButton.innerHTML = '<span>Added!</span><div class="loading__spinner hidden"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>';
            this.submitButton.classList.add('product-is-added');
            var csDiv = document.querySelector('.pro-sticky-a2c-btn');
            var csMainWrapper = document.querySelector('.product-sticky-bar');
            if(csDiv){
              csDiv.innerHTML = '<span>Added!</span>';
            }
            if(csMainWrapper){
              csMainWrapper.classList.add('product-is-added');
            }
            this.submitButton.innerHTML = '<span>Add to cart</span><div class="loading__spinner hidden"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>';
            this.submitButton.classList.remove('product-is-added');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
